<style lang="scss">
// 去除圆角
main.main-wrapper > section.tablelist .tablelist-content {
    .tablelist-searchs {
        border-radius: 0;
    }
}
main.main-wrapper > section.tablelist .tablelist-table {
    // 解决在tablelist中渲染自定义表格被自动加宽的问题
    .tablelist-custom-table {
        table {
            min-width: auto;
        }
    }

    // 去除圆角
    border-radius: 0;
    table {
        min-width: 1430px;
    }
    

    // table {
    //     min-width: 1430px;
    //     // font-size: 10px;
    // }
    // 解决Safari下横向滚动条无法拖动问题
    .vview-custome-resize-triggers,
    .vview-custome-resize-triggers > div,
    .vview-contract-resize-trigger:before {
        height: 1px;
    }
}
// 小屏幕优化
@media screen and (max-width: 1440px) {
    main.main-wrapper > section.tablelist .tablelist-table {
        .tablelist-custom-table {
            table {
                min-width: auto;
            }
        }
        table {
            min-width: 1190px;
        }
    }
}
@media screen and (max-width: 1366px) {
    main.main-wrapper > section.tablelist .tablelist-table {
        .tablelist-custom-table {
            table {
                min-width: auto;
            }
        }
        table {
            min-width: 1100px;
        }
    }
}
.tablelist-table a{
    color:#2d8cf0;
}
// 阴影太重，减轻
.vview-table-left-fixed {
    // box-shadow: 2px 2px 10px #d3d3d3;
    box-shadow: 1px 1px 2px #d3d3d3;
    // box-shadow: none;
}
.tablelist-search {
    position: relative;
    & > .tablelist-content {
        padding-left: 155px;
    }
}
.tablelist-table {
    border-radius: 8px;
}
// .tablelist-tabs {
// 	border-bottom: 1px solid #2d8cf0;
// 	margin-bottom: 10px;
// 	.vview-button {
// 		min-width: 100px;
// 		height: 36px;
// 		border-radius: 0 !important;
// 	}
// }

// .tablelist-searchs {
// 	padding: 10px 10px 0;
// 	background-color: #fff;
// 	border: 1px solid #ddd;
// 	margin-bottom: 10px;
// 	border-radius: 8px;
// 	.vview-formitem {
// 		margin-bottom: 10px;
// 	}
// }
.tablelist-tree-wrapper {
    position: absolute;
    top: 0;
    left: -5px;
    z-index: 1;
    min-height: calc(100% - 48px);
}
.tablelist-page {
    margin-top: 15px;
    // padding-bottom: 20px;
    display: flex;
    justify-content: flex-end;
}

.tablelist-tools {
    margin-bottom: 5px;
    & > * {
        margin-right: 5px;
    }
    .vview-dropdown {
        position: relative;
    }
    .vview-dropdown-list {
        min-width: 100%;
        & > * {
            line-height: 16px;
            display: block;
        }
        & > *:not(:last-child) {
            border-bottom: 1px solid #ddd;
        }
    }
}

.tablelist-dropdown .vview-dropdown-list {
    & > * {
        line-height: 16px;
        display: block;
    }
    & > *:not(:last-child) {
        border-bottom: 1px solid #ddd;
    }
}
</style>

<template>
    <section :class="{ tablelist: true, 'tablelist-search': showTreeSearchs }">
        <compTreeSearch
            class="tablelist-tree-wrapper"
            v-if="showTreeSearchs"
            v-bind="getTreeSearchsAttrs"
            @on-search="cleanUpdateSearch"
            ref="treeSearch"
        ></compTreeSearch>
        <div class="tablelist-content">
            <compTabSearch
                v-if="showTabs"
                v-bind="getTabsAttrs"
                :formData="formData"
                @on-search="cleanUpdateSearch"
                @on-tabs-change="handleTabsChange"
                :showSpan="getContextAttrs.spanTabs"
                :spanNumData="spansData"
                ref="tabSearch"
            ></compTabSearch>
            <!-- <vButtonGroup v-if="showTabs" class="tablelist-tabs clearfix" compact>
				<vButton
					v-for="(item,index) in getCompsData('Tabs')"
					:key="index"
					:theme="handleActiveTab(item)"
					@click.native="handleTabsSearch(item)"
				>{{handleCompatibleLabel(item)}}</vButton>
			</vButtonGroup>-->
            <compSearchs
                v-if="showSearchs"
                ref="compSearchs"
                v-bind="getSearchsAttrs"
                @on-search="updateSearch"
                @on-change-search="changeSearch"
            >
                <div v-if="showTools" slot="header" :class="getToolsPosClass">
                    <compOperateLink
                        v-for="(item, index) in getVisibleTools"
                        :key="index"
                        :isButton="true"
                        :data="item"
                        @on-click="handleOperates"
                    ></compOperateLink>
                    <vDropdown v-if="getMoreTools.length" trigger="click">
                        <vButton>
                            {{ $t("global.common.operation") }}
                            <vIcon type="arrow-dropdown" />
                        </vButton>
                        <template slot="list">
                            <compOperateLink
                                v-for="(item, index) in getMoreTools"
                                :key="index"
                                :data="item"
                                @on-click="handleOperates"
                            ></compOperateLink>
                        </template>
                    </vDropdown>
                </div>
                <!-- <template slot-scope="{search}">
					<vButton
						style="margin-left:5px;"
						theme="primary"
						icon="search"
						@click.native="search('search')"
					>{{$t('global.common.search')}}</vButton>
					<vButton
						style="margin-left:5px;"
						icon="refresh"
						@click.native="search('reset')"
					>{{$t('global.common.reset')}}</vButton>
					<vButton
						v-if="handleMoreSearchs"
						style="margin-left:5px;"
						theme="dashed"
						@click.native="search('more')"
					>
						{{$t('global.common.searchs')}}&nbsp;
						<vIcon type="ios-arrow-down"></vIcon>
					</vButton>
				</template>-->
            </compSearchs>
            <div ref="compTool">
                <slot name="tools"></slot>
            </div>
            <!-- <Table
                class="tablelist-table"
                v-bind="getTableAttrs"
                v-on="getListeners"
                :height="computedHeight"
                ref="table"
            ></Table> -->
            <vTable
                class="tablelist-table"
                v-bind="getTableAttrs"
                v-on="getListeners"
                ref="table"
            ></vTable>
            <vPage
                ref="compPage"
                v-if="showPage"
                class="tablelist-page"
                @on-change="updatePage"
                v-bind="getPageAttrs"
            ></vPage>
            <slot name="footer"></slot>
        </div>
        <template ref="comTemplate" v-if="showPlugins">
            <compModal
                v-model="operate.show"
                v-bind="operate"
                @on-confirm="updateList()"
                :closable="propsclosable"
            >
                <component
                    v-if="operate.component"
                    :is="operate.component"
                    v-bind="operate"
                    v-on="operate.on"
                    @on-closeCloseable="closeCloseable"
                    @on-openCloseable="openCloseable"
                    @on-close="operate = {}"
                    @on-update="updateSearch"
                    @on-current-page-update="updateSearch({}, formData.page, true)"
                />
            </compModal>
            <slot name="plugins"></slot>
        </template>
    </section>
</template>
<script>
import compUpload from "./upload";
import compSearchs from "./searchs";
import compOperateLink from "./operate-link";
import compTreeSearch from "./tree-search";
import compTabSearch from "./tab-search";
export default {
    inheritAttrs: false,
    props: {
        initFormData: Object,
        startUp: Boolean,
    },
    components: {
        compUpload,
        compSearchs,
        compOperateLink,
        compTreeSearch,
        compTabSearch,
    },
    data() {
        return {
            loading: false,
            total: 0,
            dataList: [],
            checkedData: [],
            checkedRowData: [],
            formData: {
                search: {},
            },
            operate: {
                show: false,
                loading: false,
            },
            propsclosable: true,
            spansData: {},
            computedHeight: null,
            queryPage: false
        };
    },
    beforeCreate() {
        this.$emit("on-context", this);
    },
    created() {
        if (typeof this.toolsRender === "function") {
            //自定义工具操作栏
            this.$slots.tools = this.toolsRender(this.$createElement);
        }
        this.formData = {
            ...(this.showPage
                ? { page: 1, rows: 10, sidx: "id", sord: "desc" }
                : {}),
            ...this.formData,
            ...this.initFormData,
        };
        if (this.startUp && !this.showSearchs) this.updateList();
    },
    mounted() {
        this.bus.$on("changeaside", value => {
            //自定义工具操作栏
            this.$nextTick(()=>{
                if (typeof this.toolsRender === "function") {
                    this.$slots.tools = this.toolsRender(this.$createElement);
                    this.$forceUpdate()
                }
            })
        });
        window.onresize = this.resizeThrottle(() => {
            // console.log("resize执行一次");
            this.computedTableHeight().then((height) => {
                this.computedHeight = height;
            });
        }, 50);
        this.$nextTick(() => {
            // console.log(this.$refs.compPage);
            let pageDom = this.$refs.compPage.$el;
            pageDom.addEventListener('click', (e) => {
                if (e.target.className === 'vview-page-active') {
                    console.log(e.target.innerHTML);
                    if (!this.queryPage) {
                        this.updateList({ page: this.formData.page, rows: this.formData.rows });
                    }
                }
            });
        })
    },
    beforeDestroy() {
        window.onresize = null;
    },
    watch: {
        startUp(val) {
            if (val) this.updateList();
        },
    },
    computed: {
        getContextAttrs() {
            return this.isMixin ? this : this.$attrs;
        },
        //静态分页
        getPageData() {
            const { isStatic } = this.getContextAttrs.Page || {};
            const data = this.getContextAttrs.data || this.dataList;
            if (isStatic && Array.isArray(data)) {
                const { page = 1, rows = 10 } = this.formData;
                this.total = data.length;
                return data.slice((page - 1) * rows, page * rows);
            }
            return data;
        },
        getVisibleTools() {
            return (this.getCompsData("Tools") || []).filter(function (item) {
                return item.more !== true && item.show !== false;
            });
        },
        getMoreTools() {
            return (this.getCompsData("Tools") || []).filter(function (item) {
                return item.more === true && item.show !== false;
            });
        },
        //定位工具
        getToolsPosClass() {
            const Tools = this.getContextAttrs.Tools || {};
            const posMap = {
                top: "pull-left width-100per",
                topRight: "pull-left width-100per text-right",
                // left: 'pull-left',
                right: "pull-right",
            };
            const pos = posMap[Tools.align] || "pull-left";
            return `tablelist-tools ${pos}`;
        },
        // showSpan(){
        //     return
        // },
        showTabs() {
            const Tabs = this.getContextAttrs.Tabs || {};
            return Tabs.show && this.getCompsData("Tabs") instanceof Array;
        },
        showTools() {
            const Tools = this.getContextAttrs.Tools || {};
            return Tools.show && this.getCompsData("Tools") instanceof Array;
        },
        showSearchs() {
            const Searchs = this.getContextAttrs.Searchs || {};
            return Searchs.show;
        },
        showTreeSearchs() {
            const TreeSearchs = this.getContextAttrs.TreeSearchs || {};
            return TreeSearchs.show;
        },
        showPage() {
            const Page = this.getContextAttrs.Page || { show: true };
            return Page.show;
        },
        showPlugins() {
            const Plugins = this.getContextAttrs.Plugins || {};
            return Plugins.show;
        },
        getPageAttrs() {
            return {
                showSizer: true,
                showElevator: true,
                showTotal: true,
                pageOpts: [10, 20, 50, 100],
                ...(this.getContextAttrs.Page || {}),
                total: this.total,
                pageSize: this.formData.rows,
                current: this.formData.page,
            };
        },
        getSearchsAttrs() {
            const Searchs = this.getContextAttrs.Searchs || {},
                data = this.getCompsData("Searchs");
            return { ...Searchs, data };
        },
        getTabsAttrs() {
            const Tabs = this.getContextAttrs.Tabs || {},
                data = this.getCompsData("Tabs");
            const Adaptive = this.getContextAttrs.Adaptive || {};
            return { ...Tabs, defaultKey: Tabs.key, data, Adaptive };
        },
        getTreeSearchsAttrs() {
            const TreeSearchs = this.getContextAttrs.TreeSearchs || {},
                data = this.getCompsData("TreeSearchs");
            return { ...TreeSearchs, defaultKey: TreeSearchs.key, data };
        },
        getTableAttrs() {
            const columns = (this.getContextAttrs.columns || []).map((item) => {
                const { langKey, title } = item;
                return {
                    ...item,
                    title: langKey
                        ? this.$t(langKey, { defaultValue: title })
                        : title,
                };
            });
            if (!this.isMixin) {
                columns.forEach((item) => {
                    Object.keys(item).forEach((key) => {
                        const element = item[key];
                        if (typeof element === "function")
                            item[key] = element.bind(this);
                    });
                });
            }
            return {
                border: true,
                stripe: true,
                hover: true,
                loading: this.loading,
                data: this.getPageData,
                ...this.getContextAttrs.Table,
                columns,
                noDataText: this.$t("global.common.noDataText"),
            };
        },
        getListeners() {
            return {
                "on-sort-change": this.sortChange,
                "on-filter-change": this.filterChange,
                "on-check-change": this.checkChange,
                "on-radio-change": this.checkChange,
                ...this.$listeners,
            };
        },
    },
    methods: {
        // 默认容错，mixin模式可重写此函数
        handleTabsChange (searchData) {},
        // 点击更多搜索改变高度时重新计算表格高度
        async changeSearch () {
            await this.$nextTick();
            this.computedTableHeight().then(height => {
                this.computedHeight = height;
            })
        },
        // 函数节流
        resizeThrottle(func, delay) {
            let prev = Date.now();
            return function () {
                let that = this;
                let arg = arguments;
                let now = Date.now();
                if (now - prev >= delay) {
                    func.apply(that, arg);
                    prev = Date.now();
                }
            };
        },
        // 计算表格高度以自适应
        async computedTableHeight() {
            let windowHeight = document.body.offsetHeight;
            let treeSearchHeight = 0,
                tabSearchHeight = 0,
                compSearchsHeight = 0,
                compToolHeight = 0,
                compPageHeight = 0,
                comTemplateHeight = 0;
            await this.$nextTick();
            if (this.$refs.treeSearch) {
                treeSearchHeight = this.$refs.treeSearch.$el.offsetHeight;
                // console.log('treeSearch', this.$refs.treeSearch.$el, treeSearchHeight)
            }
            if (this.$refs.tabSearch) {
                tabSearchHeight = this.$refs.tabSearch.$el.offsetHeight;
                // console.log('tabSearch', this.$refs.tabSearch.$el, tabSearchHeight)
            }
            if (this.$refs.compSearchs) {
                compSearchsHeight = this.$refs.compSearchs.$el.offsetHeight;
                // console.log('compSearchs', this.$refs.compSearchs.$el, compSearchsHeight)
            }
            if (this.$refs.compTool) {
                compToolHeight = this.$refs.compTool.offsetHeight;
                // console.log('compTool', this.$refs.compTool, compToolHeight)
            }
            if (this.$refs.compPage) {
                compPageHeight = this.$refs.compPage.$el.offsetHeight;
                // console.log('compPage', this.$refs.compPage.$el, compPageHeight)
            }
            if (this.$refs.comTemplate) {
                comTemplateHeight = this.$refs.comTemplate.$el.offsetHeight;
                // console.log('comTemplate', this.$refs.comTemplate.$el, comTemplateHeight)
            }
            let usedHeight =
                windowHeight -
                treeSearchHeight -
                tabSearchHeight -
                compSearchsHeight -
                compToolHeight -
                compPageHeight -
                comTemplateHeight -
                // 顶部navbar
                50 -
                // 顶部title
                45 -
                // 中间的3个margin，title tab search
                30 -
                // 最下方分页器的marginBottom
                
                // 分页器的marginTop
                15 -
                7;
            // let rowList = this.$refs.table.$el.querySelectorAll(
            //     ".ivu-table-row"
            // );
            let rowList = this.$refs.table.$el.querySelector('.vview-table-tbody').querySelectorAll('tr');
            if (!rowList || !rowList.length) return usedHeight;
            // table数据列的总高度 解决每个row高度不同的问题
            let rowListHeight = 0;
            let rowArray = Array.from(rowList);
            rowArray.map(item => {
                rowListHeight += item.offsetHeight;
            })
            let rowHeight = rowList[0].offsetHeight;
            // let tableHeaderHeight = this.$refs.table.$el.querySelector('.ivu-table-header').querySelector('table').offsetHeight;
            let tableHeaderHeight = this.$refs.table.$el.querySelector('.vview-table-thead').querySelector('table').offsetHeight;
            // let rowListHeight = rowHeight * rowList.length + tableHeaderHeight;
            let tableHeight = rowListHeight + tableHeaderHeight;
            let resultHeight = 0;
            if (tableHeight < usedHeight) {
                // console.log('rowListHeight', rowListHeight)
                resultHeight = tableHeight;
            } else {
                // console.log('usedHeight', usedHeight)
                resultHeight = usedHeight;
            }
            if (resultHeight < rowHeight + tableHeaderHeight) return rowHeight + tableHeaderHeight;
            return resultHeight;
        },
        closeCloseable() {
            this.propsclosable = false;
        },
        openCloseable() {
            this.propsclosable = true;
        },
        //兼容老代码name属性
        // handleCompatibleLabel(data) {
        // 	return data.langKey ? $t(data.langKey, { defaultValue: data.name || data.label }) : (data.name || data.label)
        // },
        //兼容老代码val
        // handleValAndValue(item) {
        // 	return item.value === undefined ? item.val : item.value
        // },
        getCompsData(type) {
            return (
                this.getContextAttrs[type + "Data"] ||
                this.getContextAttrs[type]["data"]
            );
        },
        // handleActiveTab(item) {
        // 	const key = item.key || this.getContextAttrs.Tabs.key,
        // 		activeVal = this.formData.search[key],
        // 		val = this.handleValAndValue(item);
        // 	return activeVal === val ? 'primary' : 'default';
        // },
        updateSearch(data = {}, page = 1, stayModal = false) {
            if (data === null) {
                //修复tab和同字段搜索重置后无法切换
                this.formData.search = {};
            } else {
                this.formData.search = Object.assign(
                    this.formData.search,
                    data
                );
            }
            this.updateList({ page: page }, stayModal);
        },
        async updatePage(page, rows) {
            this.queryPage = true;
            await this.updateList({ page, rows });
            this.queryPage = false;
        },
        sortChange(sord, sidx) {
            this.updateList({ sidx, sord });
        },
        filterChange(value, key) {
            this.updateList({ [key]: value });
        },
        checkChange(rows, val) {
            // console.log(rows,val,'val')
            this.checkedData = val;
            this.checkedRowData = rows;
        },
        getOperateNodes(h, { row }) {
            const operateNodes = [],
                operateTitle = this.$t("global.common.operation");
            this.getOperateNodeMap(row).forEach((item = {}, index) => {
                if (item.show) {
                    if (item.to) {
                        operateNodes.push(
                            <router-link
                                data-vview-module="DropdownItem"
                                props={item}
                            >
                                {item.label}
                            </router-link>
                        );
                    } else if (item.href) {
                        operateNodes.push(
                            <a data-vview-module="DropdownItem" props={item}>
                                {item.label}
                            </a>
                        );
                    } else {
                        operateNodes.push(
                            <div
                                key={index}
                                data-vview-module="DropdownItem"
                                onClick={this.handleOperates.bind(
                                    this,
                                    item.params,
                                    item.operate,
                                    false
                                )}
                            >
                                {item.label}
                            </div>
                        );
                    }
                }
            });
            return (
                <vDropdown
                    placement="bottom-left"
                    trigger="click"
                    class="tablelist-dropdown"
                >
                    <vButton size="small" theme="info">
                        {operateTitle} <vIcon type="arrow-dropdown" />
                    </vButton>
                    <template slot="list" class="text-left">
                        {operateNodes}
                    </template>
                </vDropdown>
            );
        },
        //用于清空主search数据
        cleanUpdateSearch(formData) {
            const search = this.formData.search;
            Object.keys(formData).forEach((key) => {
                this.$set(search, key, formData[key]);
            });
            this.$set(this.formData, "search", search);
            this.$nextTick(() => {
                if (this.$refs.compSearchs) {
                    //切换 多页面tab 清空老历史的搜索条件
                    this.$refs.compSearchs.search();
                    return;
                }
                // this.updateSearch();
            });
        },
        // handleTabsSearch(item) {
        // 	const datalist = this.getCompsData("Tabs"),
        // 		tabskey = this.getContextAttrs.Tabs.key,
        // 		search = this.formData.search;
        // 	//用于处理附带数据
        // 	let attachData;
        // 	datalist.forEach(itemData => {
        // 		const key = itemData.key || tabskey;
        // 		const attach = itemData.attach;
        // 		if (attach && typeof attach === 'object') {
        // 			if (item === itemData) attachData = attach;
        // 			Object.keys(attach).forEach((key) => {
        // 				this.$set(search, key, "");
        // 			})
        // 		}
        // 		this.$set(search, key, "");
        // 	});
        // 	this.$set(search, item.key || tabskey, this.handleValAndValue(item));
        // 	if (attachData) {
        // 		Object.keys(attachData).forEach((key) => {
        // 			this.$set(search, key, attachData[key]);
        // 		})
        // 	}
        // 	this.$set(this.formData, "search", search);
        // 	this.$nextTick(() => {
        // 		if (this.$refs.compSearchs) {//切换 多页面tab 清空老历史的搜索条件
        // 			this.$refs.compSearchs.search();
        // 			return;
        // 		}
        // 		this.updateSearch();
        // 	})
        // },
        handleOperates(data, type) {},
        //用于处理自定义参数结构
        // _interceptRequest() {

        // },
        async updateList(data = {}, stayModal = false) {
            if (!stayModal) {
                this.operate = {};
            }
            this.loading = true;
            this.formData = Object.assign(this.formData, data);
            const {
                interceptRequest,
                interceptResponse,
                ajaxRequest,
                spanAjaxRequest,
            } = this.getContextAttrs;
            if (this.getContextAttrs.spanTabs) {
                spanAjaxRequest()
                    .then((res) => {
                        this.spansData = res.data;
                        this.computedTableHeight().then((height) => {
                            this.computedHeight = height;
                        });
                    })
                    .catch((err) => {
                        this.loading = false;
                        this.$VMessage.error({
                            content: err.message,
                            duration: 30,
                            closable: true
                        });
                    });
            }
            if (typeof ajaxRequest === "function") {
                let params = { ...this.formData };
                if (typeof interceptRequest === "function")
                    params = interceptRequest.call(
                        this,
                        JSON.parse(JSON.stringify(params)),
                        this
                    );
                return ajaxRequest(params)
                    .then((res) => {
                        const data = res.data || {};
                        this.loading = false;
                        this.total = data.totalElements || 0;
                        this.dataList = data.content || [];
                        if (typeof interceptResponse === "function") {
                            interceptResponse.call(this, data, this);
                        } else if (
                            this.dataList[0] !== undefined &&
                            typeof this.dataList[0] !== "object"
                        ) {
                            //针对[1,2,3]组件报错问题
                            this.dataList = this.dataList.map((val) => {
                                return {
                                    key: val,
                                };
                            });
                        }
                        this.computedTableHeight().then((height) => {
                            this.computedHeight = height;
                        });
                    })
                    .catch((err) => {
                        this.loading = false;
                        this.$VMessage.error({
                            content: err.message,
                            duration: 30,
                            closable: true
                        });
                    });
            }
        },
    },
};
</script>
